/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react'
import { Tooltip } from 'react-daisyui'

interface InputProps {
    value?: string
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    placeholder?: string
    disabled?: boolean
    multiline?: boolean
    errors?: string | string[]
    warning?: string
    validation?: any
    onBlur?: (e: any) => void
    highlight?: boolean
    showValueInTooltip?: boolean
}

const FormInputField = forwardRef((props: any, ref: React.Ref<HTMLInputElement | HTMLTextAreaElement>) => {
    // Filter out non-standard HTML attributes
    const { isbold, additionalLink, error, warning, multiline, className, highlight, disabled, showValueInTooltip, ...htmlProps } = props

    const [border, setBorder] = useState<string>('border border-[#D4D4DA]')

    useEffect(() => {
        if (props.disabled) {
            setBorder('border border-[#D4D4DA]')
        } else if (error) {
            setBorder('border-2 border-red-500')
        } else if (highlight) {
            setBorder('border border-yellow-500 ring-2 ring-yellow-400/60')
        } else {
            setBorder('border border-grey')
        }
    }, [props])

    return (
        <div className="relative  w-full">
            {multiline ? (
                <textarea
                    id={htmlProps.id}
                    ref={ref} // Forward the ref to the textarea
                    className={`w-full text-[.6rem] min-h-[1.709rem] h-[1.709rem] leading-[1.3] border border-[#D4D4DA] px-2 py-[0.43rem] disabled:bg-[#E6E7EA] rounded-[0.267rem] focus:outline-none ${border} ${className || ''}`}
                    {...htmlProps}
                    required={false}
                    rows={3}
                />
            ) : (
                <>
                    {showValueInTooltip ? (
                        <Tooltip message={props.value || ''} color="info" className="w-full">
                            <input
                                disabled={disabled || false}
                                id={htmlProps.id}
                                ref={ref} // Forward the ref to the input
                                type="text"
                                {...{ ...htmlProps, required: false }}
                                className={`w-full h-[1.709rem] text-[.6rem] outline-1-[0.5px] px-2 rounded-[0.267rem] focus:outline-none truncate disabled:bg-[#E6E7EA] ${border} ${className || ''}`}
                            />
                        </Tooltip>
                    ) : (
                        <input
                            disabled={disabled || false}
                            id={htmlProps.id}
                            ref={ref} // Forward the ref to the input
                            type="text"
                            {...{ ...htmlProps, required: false }}
                            className={`w-full h-[1.709rem] text-[.6rem] outline-1-[0.5px] px-2 rounded-[0.267rem] focus:outline-none truncate disabled:bg-[#E6E7EA] ${border} ${className || ''}`}
                        />
                    )}
                </>
            )}
            {additionalLink?.()}
            {error && <p className="text-error text-[.542rem] mt-1 leading-[1.2]">{typeof error === 'string' ? error : error?.join(', ')}</p>}
            {warning && <p className="text-[#2d4179] text-[.542rem] mt-1 leading-[1.2]">{typeof warning === 'string' ? warning : ''}</p>}
        </div>
    )
})

// Assign a display name to the component
//FormInputField.displayName = 'FormInputField'

export default FormInputField
